import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoTerminos from "../legal/InfoTerminos";
const Footer = lazy(() => import('../footer/Footer'));
function Terminos() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Bienvenido al sitio web oficial de Hyundai Ecuador. Conoce nuestra amplia gama de modelos, concesionarios y todos los servicios especialmente pensados para ti."
        />
        <meta
          name="keywords"
          content="terminos, condiciones, Hyundai"
        />
        <title>Hyundai términos y condiciones</title>
      </Helmet>
      <Menu />
      <InfoTerminos />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Terminos;